// ScrollModal.jsx
import React, { useEffect, useState, useRef } from 'react';
import ReactDOM from 'react-dom';
import ctaConfig from '../../config/ctaConfig.jsx';
import './scrollModal.css';

const ScrollModal = ({props}) => {
  const [showModal, setShowModal] = useState(false);
  const targetRef = useRef(null);
  // Ref to ensure the modal triggers only once per page load.
  const hasTriggeredRef = useRef(false);
  // Record the time when the component mounts.
  const mountTimeRef = useRef(Date.now());

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries, observerInstance) => {
        entries.forEach((entry) => {
          // Check how much time has passed since mount.
          const elapsedTime = Date.now() - mountTimeRef.current;
          // Trigger modal when the target is at least 50% visible,
          // the modal has not yet triggered, and at least 3 seconds have elapsed.
          if (entry.isIntersecting && !hasTriggeredRef.current && elapsedTime > 3000) {
            setShowModal(true);
            hasTriggeredRef.current = true;
            observerInstance.disconnect();
          }
        });
      },
      {
        threshold: 0.5, // Adjust threshold if needed.
      }
    );

    if (targetRef.current) {
      observer.observe(targetRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  const closeModal = () => {
    setShowModal(false);
  };

  // Retrieve the CTA data using the ctaKey prop from props.
  const ctaData = ctaConfig[props.ctaKey] || {};

  return (
    <>
      {/* Target element for the Intersection Observer */}
      <div ref={targetRef} style={{ height: '1px' }} />
      {showModal &&
        ReactDOM.createPortal(
          <div className="overlay">
            <div className="overlay-content">
              {ctaData.content || (
                <p>This is a placeholder for your CTA content. Customize this as needed.</p>
              )}
              <div className="button-container">
                <button className="back-button" onClick={closeModal}>
                  Back
                </button>
                <a
                  href={ctaData.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="cta-button"
                >
                  {ctaData.button || 'Get Offer'}
                </a>
              </div>
            </div>
          </div>,
          document.body
        )}
    </>
  );
};

export default ScrollModal;
